module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../node_modules/happypack/loader.js?id=jsx!./SupplementaryCardView.js"));
	}, "SupplementaryCardView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SupplementaryCardView!./src/pages/Shop/Member/Personal/SupplementaryCard/SupplementaryCardView.js
// module id = 1475
// module chunks = 418